import React from "react";
import "./deals.scss";
import dealsPotrait from "../../../asset/september-deals.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const Deals = () => {
  const waOpen = () => {
    window.open(
      "https://api.whatsapp.com/send?phone=6287818641024&text=Halo%20Dimas%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(September%20Deals)%20(https://marketing-kotabaruparahyangan.com/)%20?&fbclid=PAAaa7g9IJ-tB3RyMunLD6w_5ysqP4oI6PA2d9Ml7Isc1_OXjeOiGuAqu7Ap0",
      "_blank",
    );
  };

  return (
    <div className="deals-section" id="bcaexpo">
      <div className="container-deals">
        <div className="header-deals">
          <h2 className="title">September Deals</h2>
          <div className="subtitle">at BCA Expo</div>
        </div>
        <div className="gambar-deals">
          <img
            src={dealsPotrait}
            className="potrait"
            alt="September Deals at BCA Expo Kota Baru Parahyangan"
          />
        </div>
        <button onClick={waOpen} className="btn-navbar">
          <FontAwesomeIcon icon={faWhatsapp} /> &nbsp; Dapatkan Promo September
          Deals
        </button>
      </div>
    </div>
  );
};

export default Deals;
